import React from 'react';
import PropTypes from 'prop-types';
import { Pagination } from '@silverrailtech/srtlibrary';
import inlineStyles from './styles';

const VouchersPagination = ({ currentPage, onPageChange, totalPages }) => {
	if (totalPages <= 1) {
		return null;
	}

	return (
		<div style={inlineStyles.paginationWrapper}>
			<Pagination
				count={totalPages}
				page={currentPage + 1}
				onChange={(_, newPage) => onPageChange(newPage - 1)}
			/>
		</div>
	);
};

VouchersPagination.propTypes = {
	currentPage: PropTypes.number.isRequired,
	onPageChange: PropTypes.func.isRequired,
	totalPages: PropTypes.number.isRequired,
};

export default VouchersPagination;
